export const initialState = {
    data: {
        trucks: [],
    },
    dialogs: {
        deleteConfirm: false,
        addConfirm: false,
        editConfirm: false,
        viewConfirm: false,
        selectedRecord: null,
    },
    forms: {
        addTruckForm: {
            plateNumber: "",
            type: "",
            subType: "",
            size: "",
            tareWeight: "",
            capacity: "",
            capacityUnit: "",
            vehicleSerialNumber: "",
        },
        editTruckForm: {
            plateNumber: "",
            type: "",
            subType: "",
            size: "",
            tareWeight: "",
            capacity: "",
            capacityUnit: "",
            vehicleSerialNumber: "",
        },
        viewTruckForm: {
            plateNumber: "",
            type: "",
            subType: "",
            size: "",
            tareWeight: "",
            capacity: "",
            capacityUnit: "",
            vehicleSerialNumber: "",
        },
        initialEditTruckForm: {
            plateNumber: "",
            type: "",
            subType: "",
            size: "",
            tareWeight: "",
            capacity: "",
            capacityUnit: "",
            vehicleSerialNumber: "",
        },
    },
    ui: {
        vehicleTypeOptions: [],
        capacityUnitOptions: [],
        vehicleData: {},
    },
    loading: {
        isLoadingBackdrop: false,
        isBackgroundRefreshing: false,
        isVehicleTypeLoading: false,
        isCapacityUnitLoading: false,
        isVehicleSubTypeLoading: false,
    },
    table: {
        searchInput: "",
        currentPage: 1,
        recordsPerPage: 10,
    },
};

export function manageTrucksReducer(state, action) {
    switch (action.type) {
        case "SET_TRUCKS":
            return {
                ...state,
                data: {
                    ...state.data,
                    trucks: action.payload || [],
                },
            };
        case "OPEN_DELETE_DIALOG":
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    deleteConfirm: true,
                    selectedRecord: action.payload,
                },
            };

        case "CLOSE_DELETE_DIALOG":
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    deleteConfirm: false,
                    selectedRecord: null,
                },
            };

        case "OPEN_EDIT_DIALOG":
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    editConfirm: true,
                    selectedRecord: action.payload.record,
                },
                forms: {
                    ...state.forms,
                    editTruckForm: action.payload.editFormData,
                    initialEditTruckForm:
                        action.payload.initialEditTruckForm ?? action.payload.editFormData,
                },
            };

        case "CLOSE_EDIT_DIALOG":
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    editConfirm: false,
                    selectedRecord: null,
                },
                forms: {
                    ...state.forms,
                    editTruckForm: initialState.forms.editTruckForm,
                    initialEditTruckForm: initialState.forms.initialEditTruckForm,
                },
            };

        case "OPEN_ADD_DIALOG":
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    addConfirm: true,
                },
            };

        case "CLOSE_ADD_DIALOG":
            return {
                ...state,
                forms: {
                    ...state.forms,
                    addTruckForm: initialState.forms.addTruckForm,
                },
                dialogs: {
                    ...state.dialogs,
                    addConfirm: false,
                },
            };

        case "OPEN_VIEW_DIALOG":
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    viewConfirm: true,
                    selectedRecord: action.payload.record,
                },
                forms: {
                    ...state.forms,
                    viewTruckForm: action.payload.viewFormData,
                },
            };

        case "CLOSE_VIEW_DIALOG":
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    viewConfirm: false,
                    selectedRecord: null,
                },
                forms: {
                    ...state.forms,
                    viewTruckForm: initialState.forms.viewTruckForm,
                },
            };

        case "UPDATE_FORM_FIELD":
            return {
                ...state,
                forms: {
                    ...state.forms,
                    [action.payload.formName]: {
                        ...state.forms[action.payload.formName],
                        [action.payload.fieldName]: action.payload.value,
                    },
                },
            };

        case "SET_LOADING":
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [action.payload.key]: action.payload.value,
                },
            };

        case "SET_SEARCH_INPUT":
            return {
                ...state,
                table: {
                    ...state.table,
                    searchInput: action.payload,
                    currentPage: 1,
                },
            };

        case "SET_CURRENT_PAGE":
            return {
                ...state,
                table: {
                    ...state.table,
                    currentPage: action.payload,
                },
            };

        case "SET_VEHICLE_TYPE_OPTIONS":
            return {
                ...state,
                ui: {
                    ...state.ui,
                    vehicleTypeOptions: action.payload || [],
                },
            };

        case "SET_CAPACITY_UNIT_OPTIONS":
            return {
                ...state,
                ui: {
                    ...state.ui,
                    capacityUnitOptions: action.payload || [],
                },
            };

        case "SET_VEHICLE_DATA":
            return {
                ...state,
                ui: {
                    ...state.ui,
                    vehicleData: action.payload || {},
                },
            };

        default:
            return state;
    }
}
